import { getUA } from './use-web-rtc'

export const register = (): void => {
  getUA()?.register()
}
